import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { routes } from '../../config';
import images from '../../utils/images';
import ReactGa from 'react-ga';

const ThankyouPage = ({history}) => {
  const email = history.location.state && history.location.state.email ? history.location.state.email : '';
  const name = history.location.state && history.location.state.name ? history.location.state.name : '';
  const price = history.location.state && history.location.state.price ? history.location.state.price : '';
  
  useEffect(() => {
	
	ReactGa.initialize('UA-180777105-1')
	// Report the page view name
	ReactGa.pageview(window.location.pathname + window.location.search)
	
	ReactGa.event({
		category:'Exit',
		action: 'User Journey Completed',
		label: 'User - ' + name + ' Won Price Id:' + price.id
	})
	
  }, []); // eslint-disable-line

  return (
    <div className="page-wrapper">
      <div className="page-root">
        <main>
          <section>
            <img src={images.heroBanner2021} className="img-fluid" alt="CHIMICHNAGA" />
          </section>
          <section className="user-thankyou-section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-10 mb-2 text-center">                  
                  <div className="thankyou-message  mb-4 my-md-5">
                    <h2 className="text-center">Dear {name}!<br/><br/>Thank you for participating in Chimichanga VivoCity's Spin & Win.</h2>
                    <div className="prizeBlock">
                      <h2 className="text-center pricePreText">                     
                        <span>
                          You’ve won
                        </span>
                      </h2>                    
                      <h1 className="text-center priceText">{price.name}</h1>
                    </div>                    
                        <h4 className="mb-1">
                        Check your email for e-voucher & redemption details
                        </h4>
                        <div style={{ marginBottom: '0.3rem' }} >
                          <b>(remember to check your junk mail too).</b>
                        </div>
                        <h4 style={{textTransform: 'none', fontWeight: 'bold' }}>{email}</h4>
                  </div>
                </div>
                <div className="col-8 d-none col-md-5">
                  <img src={images.logo} className="img-fluid logo" alt="CHIMICHNAGA" onClick={() => history.push(routes.home)}/>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default withRouter(ThankyouPage);
